export enum Languages {
    Dutch = 'nl-nl',
    English = 'en-gb',
    French = 'fr-fr',
    German = 'de-ch',
    Italian = 'it-it',
    Swedish = 'sv-se'
}

export type LanguageOption = {
    name: string;
    value: Languages;
};
